import React, { useState } from 'react';
import contentfulRichTextOptions from 'components/RichText/options/contentfulRichTextOptions';
import { generateRichTextFAQ } from 'utils/seo';
import parseRichTextArticle from 'utils/parseRichTextArticle';
import TableOfContents from 'components/Page/BlogDetailsTemplate/BlogTableOfContents';
import SidebarV2 from 'components/Sections/Sidebar/SidebarV2';
import { Col, Row } from 'components/Core/Grid';
import { Helmet } from 'react-helmet';
import StyledRichText from '../StyledRichText';
import ContentfulRichTextContainer from './styles';
import RichText from '..';
import TocRichText from './TableOfContents/TocRichText';
import { ExpandContent, GatedForm } from './ExpandableComponents';

const ContentfulRichText = ({ richText, dataPosition, className, templateId }) => {
  const [isExpandable, toggleExpandable] = useState(richText?.expandable || richText?.gatedContent);

  if (!richText) {
    return null;
  }

  const {
    content,
    styles,
    color,
    tableOfContents: useSideBarToC,
    blogContentStyling,
    textAlignment,
    alignmentDesktop,
    alignmentMobile,
    listIcon,
    expandable,
    gatedContent,
    faq,
  } = richText || {};

  const toc = parseRichTextArticle(content, useSideBarToC ? 'v2' : 'v1')?.toc || null;

  const body = parseRichTextArticle(content, useSideBarToC ? 'v2' : 'v1')?.body || null;

  const faqSchema = useSideBarToC && faq && generateRichTextFAQ(body);

  const containerStyles = {
    ...styles,
    color,
    textAlignment,
    alignDesktop: alignmentDesktop,
    alignMobile: alignmentMobile,
    listIcon: listIcon?.image?.file?.url || listIcon,
  };

  const optionsContent = { ...richText, dataPosition };
  const backgroundImageUrl = containerStyles?.backgroundImage?.image?.file?.url;

  const Content = useSideBarToC ? (
    <TocRichText content={body} toc={toc} className="styled-rich-text" />
  ) : blogContentStyling ? (
    <StyledRichText content={body} className="styled-rich-text" />
  ) : (
    <RichText content={body} options={contentfulRichTextOptions(optionsContent)} />
  );

  return (
    <>
      {faqSchema && (
        <Helmet>
          {faqSchema && <script type="application/ld+raw">{JSON.stringify(faqSchema)}</script>}
        </Helmet>
      )}
      {expandable && !gatedContent && isExpandable && (
        <ExpandContent onClick={() => toggleExpandable(false)} />
      )}
      {gatedContent && isExpandable && <GatedForm onSuccess={() => toggleExpandable(false)} />}
      <ContentfulRichTextContainer
        backgroundImageUrl={backgroundImageUrl}
        {...containerStyles}
        className={`rich-text--container ${className || ''} ${templateId || ''}`}
        $customCss={styles?.customStyling?.customStyling}
        isExpandable={isExpandable}
      >
        {toc ? (
          !useSideBarToC ? (
            <>
              <TableOfContents content={toc} />
              {Content}
            </>
          ) : (
            useSideBarToC && (
              <Row gutter={[24, 0]}>
                <Col xs={24} sm={24} md={16} lg={16}>
                  {Content}
                </Col>
                <Col
                  xs={0}
                  sm={0}
                  md={8}
                  lg={8}
                  style={{ paddingTop: '40px' }}
                  className="richtext-sidebar--parent"
                >
                  <SidebarV2 toc={toc} demo classNames="richtext-sidebar--container" />
                </Col>
              </Row>
            )
          )
        ) : (
          Content
        )}
      </ContentfulRichTextContainer>
    </>
  );
};

export default ContentfulRichText;
